import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import { AmplifyPlugin } from 'aws-amplify-vue';
import AwsExports from "./aws-exports";
import Amplify, * as AmplifyModules from 'aws-amplify';

Amplify.configure(AwsExports);

Vue.use(AmplifyPlugin, AmplifyModules);

Vue.config.productionTip = false



new Vue({
  router,
  
  store,
  render: h => h(App),
}).$mount('#app')
